export default "__VITE_ASSET__DD8HGfx3__"